import {
  APPLY_JOB_LIST_REQUEST,
  APPLY_JOB_LIST_SUCCESS,
  APPLY_JOB_LIST_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const ApplyJobAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: APPLY_JOB_LIST_REQUEST,
      payload: true,
    });

    return new Promise((resolve, reject) => {
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/applied_jobs`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };

      axios(OPTION)
        .then((res) => {
          dispatch(updateDashboardContentPre(res.data));
          resolve(res?.data);
        })
        .catch((error) => {
          toast.error(error.response.data.status.message);
          dispatch({
            type: APPLY_JOB_LIST_FAIL,
            payload: false,
            error: error,
          });
          reject(error)
        });
    })


  };
};

export const updateDashboardContentPre = (data) => {
  toast.success(" Job Applied Successfully!");
  return {
    type: APPLY_JOB_LIST_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};